<template>
  <div class="container flex items-start justify-between gap-4">
    <SiteMenuTop class="mt-4" />
    <SiteHeaderTools />
  </div>
</template>
